const o = "platformApi.errors", s = `${o}.default`, R = /^.+-.+$/, f = (t) => R.test(t), i = (t) => {
  if (t === null || typeof t != "object" || !("error" in t))
    return !1;
  const r = t.error;
  if (r === null || typeof r != "object")
    return !1;
  const { code: e, statusCode: n } = r;
  return typeof e == "string" || typeof n == "number";
}, A = (t) => `${o}.${t}`, l = (t) => f(t) ? A(t) : s;
export {
  s as PLATFORM_API_DEFAULT_ERROR_TRANSLATION_KEY,
  o as PLATFORM_API_ERROR_TRANSLATION_PREFIX,
  A as getPlatformApiErrorTranslationKey,
  l as getPlatformApiErrorTranslationKeyFromError,
  f as isPlatformApiErrorCode,
  i as isPlatformApiErrorResponse
};
